import { exact, string } from 'prop-types';

import { CategoriesType } from './categories.type';
import { ClustersType } from './clusters.type';
import { CollectiblesType } from './collectibles.type';
import { DemosType } from './demo.type';
import { IconsType } from './icons.type';
import { MapType } from './map.type';
import { RegionsType } from './regions.type';
import { TagsType } from './tags.type';

export const DefaultConfig = {
  categories: [],
  clusters: {},
  collectibles: [],
  demo: [],
  icons: {},
  id: null,
  map: {},
  regions: [],
  tags: [],
  title: null,
};

export const ConfigType = exact({
  categories: CategoriesType.isRequired,
  clusters: ClustersType.isRequired,
  collectibles: CollectiblesType.isRequired,
  demo: DemosType.isRequired,
  icons: IconsType.isRequired,
  id: string.isRequired,
  map: MapType.isRequired,
  regions: RegionsType.isRequired,
  tags: TagsType.isRequired,
  title: string.isRequired,
});
